import { Icon } from '@leroy-merlin-br/backyard-react-ui'
import { ChevronDownSolid } from '@leroy-merlin-br/backyard-react-icons'

import { ClearButton } from './components/ClearButton'
import * as S from './styled'

const Select = ({ children, name, value, placeholder, onChange }) => (
  <S.SelectContainer isSelected={value}>
    <S.IconContainer>
      {value && (
        <ClearButton onClick={() => onChange(1, '')} />
      )}
      {!value && <Icon as={ChevronDownSolid} size="byte" />}
    </S.IconContainer>

    <S.Select
      name={name}
      value={value}
      onChange={event => onChange(event.target.selectedIndex, event.target.value)}
    >
      {!value && (
        <option key={placeholder} value="" disabled>
          {placeholder}
        </option>
      )}
      {children}
    </S.Select>
  </S.SelectContainer>
)

export default Select
